import { Link, useParams } from 'react-router-dom';
import { useLoadTags } from '@features/common';
import { ButtonVisitors } from '@features/event-page/button-visitors';
import { ArrowShortLeft } from '@shared/assets';
import { IconButton, ListBody, PageHead, PageTitle } from '@shared/ui';
import {
  Contacts,
  Description,
  Directions,
  EventBlocks,
  Information,
  Presenter,
  PresentVideo,
  VisitorActions,
} from '@src/features/event-page';
import { Loader } from 'library/components/common';
import { EventEnd, EventModeration, Menu } from 'library/components/events';
import { checkEventEnd } from 'library/helpers/events/dateSets';
import { useEvent, useModeration, useTickets } from 'library/hooks/events';
import * as st from './styles.module.scss';

export const EventPage = () => {
  const { isLoadingTags } = useLoadTags('specialists');
  const event = useEvent();
  const moderation = useModeration({ event: event?.event, isAuthor: event.isAuthor });
  const { code } = useParams<{ code: string }>();
  const { count } = useTickets();

  return (
    /**
     * TODO: Удалить неиспользуемый код после полного тестирования
     */
    <>
      {event.status === 'loaded' && event.event && !isLoadingTags ? (
        <>
          <PageTitle title="Мероприятие" />

          <PageHead
            Left={
              <Link to={`/events/${code}`}>
                <IconButton variant="dark">
                  <ArrowShortLeft />
                </IconButton>
              </Link>
            }
            Right={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className={st.header__moderation}>
                  {checkEventEnd(event.event.time_to) && moderation.showModeration ? (
                    <div className={st.header__end}>
                      <EventEnd size="large" />
                    </div>
                  ) : (
                    moderation.showModeration && (
                      <EventModeration
                        status={event.event.moderation_status.abbr_status}
                        published={event.event.published}
                        publicate={moderation.publicateEvent}
                        // showModerationStatus={moderation.showModerationStatus}
                        showModerationText={moderation.showModerationText}
                      />
                    )
                  )}
                </div>
                <div className={st.header__actions}>
                  {event.isAuthor ? (
                    <ButtonVisitors
                      timeEnd={event.event.time_to}
                      mode={event.event.mode}
                      count={count}
                    />
                  ) : (
                    <VisitorActions
                      availablePlaces={event.event.places}
                      timeEnd={event.event.time_to}
                      timeStart={event.event.time_from}
                      mode={event.event.mode}
                      href={event.event.external_service}
                    />
                  )}
                </div>

                <div className={st.header__menu}>
                  <Menu event={event.event} hasTickets={count > 0} />
                </div>
              </div>
            }
          />

          <ListBody>
            <div className={st.body}>
              <div>
                <h1>{event.event.title}</h1>
                <Description
                  image={event.event.event_image}
                  description={event.event.description}
                />
              </div>
              {event.event.presentation_video && (
                <div>
                  <PresentVideo video={event.event.presentation_video} />
                </div>
              )}
              {!!event.event.event_coach.length && (
                <div>
                  <Presenter presenters={event.event.event_coach} />
                </div>
              )}

              {!!event.event.event_block.length && (
                <div className={st.audience}>
                  <EventBlocks eventBlocks={event.event.event_block} />
                </div>
              )}

              <div>
                <Information
                  eventInfo={event.event}
                  isAuthor={event.isAuthor}
                  soldTickets={count}
                />
              </div>

              {event.event.address && (
                <div>
                  <Directions direction={event.event.address.description} />
                </div>
              )}

              {event?.event?.contacts.length > 0 && (
                <div>
                  <Contacts contacts={event?.event?.contacts} />
                </div>
              )}
            </div>
          </ListBody>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};
